<template>
    <div style="display: flex; flex-direction: column; position: relative;" >
        <div style="position: absolute; left: 0; top: 0; width: 100%; height: 100%; background-color: red; display: flex; flex-direction: column;">
            <div style="flex: 1; background-color: var(--color-main); display: flex; flex-direction: column; justify-content: center; color: #fff; align-items: center;">
                <template v-if="!isLater">
                    <div style="font-weight: 500; font-size: 20px; line-height: 30px; margin-bottom: 5px;">사커하우를 시작하기 전에,</div>
                    <div style="font-weight: 700; font-size: 24px; text-align: center; line-height: 36px;">내 플레이 성향에 딱 맞는<br>최적의 포지션을<br>먼저 찾아볼까요?</div>
                </template>
                <template v-else>
                    <div style="font-weight: 700; font-size: 24px; text-align: center; line-height: 36px;">언제든 원하실 때,<br>내 포지션은 찾아볼 수 있어요!</div>
                    <div style="font-weight: 500; line-height: 36px; margin-top: 5px;">지금은 사커하우의 다른 기능들을 먼저 둘러보세요!</div>
                </template>
            </div>
            <div style="position: absolute; bottom: 0; width: 100%; text-align: center; background-color: var(--color-main);">
                <template v-if="!isLater">
                    <div @click="goFindPosition" class="common_btn">좋아요. 내 포지션 찾아볼래요!</div>
                    <div @click="doLater" class="later_btn">나중에 할게요</div>
                </template>
                <template v-else>
                    <div @click="goHome" style="margin-bottom: 57px;" class="common_btn">홈으로 가기</div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import { GROUP_IDX } from '@/Constants'

export default {
    name: 'SignupFindPosition',
    data() {
        return {
            isLater: false,
            GROUP_IDX: GROUP_IDX
        }
    },
    created() {
        window.deviceInfoManager.setStatusBarTextColor('white');
    },
    destroyed() {
        window.deviceInfoManager.setStatusBarTextColor('dark');
    },
    props: {
        selectedPurpose: {
            type: Number,
            default: GROUP_IDX.COURSE
        }
    },
    methods: {
        goFindPosition() {
            this.$GlobalStore.addModal('FindPositionHome', { completeAction: this.completeAction })
        },
        completeAction() {
            this.isLater = true;
            this.$GlobalStore.closeLastModal()
            this.$Util.checkAfterLogin(true);
        },
        doLater() {
            this.isLater = !this.isLater;
        },
        goHome() {
            this.$GlobalStore.closeLastModal()
            this.$router.push({ path: '/view/home' + '?time=' + new Date().getTime(), props: { data: { mode: 'page' } } });
            if (this.selectedPurpose === GROUP_IDX.COURSE) {
                this.$GlobalStore.setIsShowRequestPopupForce(true)
            } else {
                this.$GlobalStore.setIsShowPositionPopup(true)
            }
            this.$Util.checkAfterLogin(true);
        }
    }
}
</script>

<style scoped>
.common_btn {
    width: calc(100% - 48px);
    background-color: #FFF3F3;
    margin: 0 auto;
    text-align: center;
    height: 48px;
    line-height: 48px;
    border-radius: 12px;
    color: var(--color-main);
    font-weight: 700;
    margin-bottom: 12px;
}

.later_btn {
    text-align: center;
    color: #fff;
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
    margin-bottom: 22px;
    display: inline-block;
    border-bottom: 1px solid #fff;
}
</style>